<template>
  <!--  <div id="name">-->
  <!--    <div id="editWorkflowNameForm" class="row">-->

  <div class="container">
    <div id="name" class="row clearfix">
      <div id="editWorkflowNameForm" class="row col-lg-12 col-md-12 col-sm-12">
        <div class="header"><h2>제목:</h2></div>

        <div class="body">
          <div class="row clearfix">
            <div class="col-sm-12">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  id="editNameInp"
                  maxlength="21"
                  style="
                    width: 160%;
                    border-top: none;
                    border-right: none;
                    border-left: none;
                    border-color: #d7d7d7;
                    border-radius: 0;
                  "
                  @keyup="checkName()"
                  v-model="workflowStore.workflowName"
                />
              </div>
            </div>
          </div>
        </div>

        <!--      <input-->
        <!--        type="text"-->
        <!--        class="form-control col-sm-3"-->
        <!--        id="editNameInp"-->
        <!--        maxlength="21"-->
        <!--        @keyup="checkName()"-->
        <!--        v-model="workflowStore.workflowName"-->
        <!--        :disabled="editNameState"-->
        <!--      />-->
        <!--      <button-->
        <!--        class="btn btn-default"-->
        <!--        id="editNameBtn"-->
        <!--        v-if="editNameState == true"-->
        <!--        @click="editName"-->
        <!--      >-->
        <!--        이름수정-->
        <!--      </button>-->
        <!--      <button-->
        <!--        class="btn btn-default"-->
        <!--        id="editNameBtn"-->
        <!--        v-if="editNameState == false"-->
        <!--        @click="editName"-->
        <!--      >-->
        <!--        이름저장-->
        <!--      </button>-->
      </div>
    </div>
  </div>
</template>

<script>
// import Urls from "@/common/urls";
// import Apiroot from "@/common/apiroot";

export default {
  name: "name",
  data() {
    return {
      workflowName: "",
      editNameState: true,
    };
  },
  computed: {
    userStore() {
      return this.$store.state.userStore;
    },
    workflowStore() {
      return this.$store.state.workflowStore;
    },
  },
  methods: {
    editName() {
      this.editNameState = !this.editNameState;
    },
    checkName() {
      var len = 0;
      var name = this.workflowStore.workflowName;

      for (var i = 0; i < name.length; i++) {
        if (escape(name.charAt(i)).length == 6) {
          len++;
        }
        len++;
      }

      if (len > 21) {
        console.log(name.substr(0, 21));
        this.$store.dispatch("changeWorkflowName", name.substr(0, 21));
      }
    },
    trueFalse() {
      this.editNameState = !this.editNameState;
      return !this.editNameState;
    },
    // workflow 저장
    // createWorkflow() {
    //   var param = {
    //     groupCode : "GROU20211101172723784",
    //     userCode : this.$store.state.userStore.userCode,
    //     workflowName : this.workflowName,
    //     workflowSchema : "schema",
    //   }
    //   this.$store.dispatch('postSend', { paths : Apiroot.workflow + Urls.createWorkflow , params : param})
    //   .then((res) => {
    //     console.log(res)
    //   }).catch((error) => {
    //     console.log(error)
    //   })
    // }
  },
  created() {},
};
</script>
